
import simple_select from './simple_select';
import direct_select from './direct_select';
import draw_point from './draw_point';
import draw_polygon from './draw_polygon';
import draw_line_string from './draw_line_string';
import static_mode from './static_mode';

import custom from './custom/index'

export default {
  simple_select,
  direct_select,
  draw_point,
  draw_polygon,
  draw_line_string,
  static: static_mode,

  ...custom
};
